import React from "react";
import { Link } from "react-router-dom";
import { Printer, Phone, MessageCircle, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { BUSINESS } from "@/data/business";
import { SERVICES } from "@/data/services";

const KN_NAME = SERVICES.reduce((a, s) => { a[s.id] = s.name_kn; return a; }, {});

export const Footer = () => {
  const { lang, tr } = useLang();
  const { content, business, waLink } = useContent();
  const kn = lang === "kn";

  return (
    <footer className="bg-slate-950 text-slate-300 pb-24 lg:pb-0">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-md bg-primary text-white"><Printer size={20} /></span>
              <span className="font-heading text-lg font-extrabold text-white">Creative Prints</span>
            </div>
            <p className={`mt-3 text-sm text-slate-400 ${kn ? "font-kn" : ""}`}>{kn ? BUSINESS.tagline_kn : BUSINESS.tagline_en}</p>
            <p className={`mt-4 text-xs text-slate-500 ${kn ? "font-kn" : ""}`}>{tr("footer_note")}</p>
          </div>

          <div>
            <h4 className={`font-heading font-bold text-white ${kn ? "font-kn" : ""}`}>{tr("footer_services")}</h4>
            <ul className="mt-4 space-y-2">
              {content.services.map((s) => (
                <li key={s.id}>
                  <a href="#services" className={`text-sm text-slate-400 hover:text-primary transition-colors ${kn ? "font-kn" : ""}`}>
                    {kn && KN_NAME[s.id] ? KN_NAME[s.id] : s.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className={`font-heading font-bold text-white ${kn ? "font-kn" : ""}`}>{tr("footer_contact")}</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><a href={`tel:${business.phone}`} className="flex items-center gap-2 text-slate-400 hover:text-primary"><Phone size={15} /> {business.phoneDisplay}</a></li>
              <li><a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-slate-400 hover:text-[#25D366]"><MessageCircle size={15} /> WhatsApp</a></li>
              <li className="flex items-start gap-2 text-slate-400"><MapPin size={15} className="mt-0.5 shrink-0" /> <span className={kn ? "font-kn" : ""}>{business.address}</span></li>
            </ul>
          </div>

          <div>
            <h4 className={`font-heading font-bold text-white ${kn ? "font-kn" : ""}`}>{tr("footer_hours")}</h4>
            <p className={`mt-4 text-sm text-slate-400 ${kn ? "font-kn" : ""}`}>{kn ? BUSINESS.hours_kn : business.hours_en}</p>
            <Link to="/admin" data-testid="footer-admin-link" className="mt-6 inline-block text-xs font-semibold text-slate-500 hover:text-primary underline">
              {tr("nav_admin")}
            </Link>
          </div>
        </div>

        <div className="mt-12 border-t border-slate-800 pt-6 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} Creative Prints, Vidyaranyapura, Bengaluru. {tr("footer_rights")}
        </div>
      </div>
    </footer>
  );
};
